<!--=======================================
=            LAYOUT HORIZONTAL            =
========================================-->
<template>
  <div>
    <!-- system bar-->
   
    <!-- horizontal menu-->
    <v-app-bar :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" app flat>
      <v-avatar class="hidden-sm-and-down" color="transparent" size="42">
        <img src="../assets/images/logo-mini.png">
      </v-avatar>
      <drawer-horizontal></drawer-horizontal>
    </v-app-bar>
    <!--drawer right -->
    <v-navigation-drawer v-model="drawerRight" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" temporary fixed class="d-print-none mx-auto" :right="!$vuetify.rtl">
      <base-settings></base-settings>
    </v-navigation-drawer> 
    <!-- main-->
    <v-main  :class="$vuetify.theme.dark ? 'dark' : 'light'">
      <v-container class="transparent mb-10">
        <sequential-entrance>  <router-view></router-view>  </sequential-entrance>
        <v-btn @click.stop="drawerRight=!drawerRight" class=" product-upgrade-to-pro error">
          <v-icon size="30" dark> settings
          </v-icon>
        </v-btn>
      </v-container>
    </v-main>
    <!--footer -->
    <base-footer></base-footer>
  </div>
</template>

<script>
  import DrawerHorizontal from '../components/Drawer/DrawerHorizontal'
  import BaseSettings from '../components/Base/BaseSettings'
  import BaseFooter from '../components/Base/BaseFooter'
  export default {
    components: {
      DrawerHorizontal,
      BaseSettings,
      BaseFooter
    },
    data() {
      return {
        drawerRight: false,
        sidebarMenu: true,
        drawer: true,
        searchActive: false,
        align: 'center',
      }
    },
  }
</script>

<style>
  .light {
    background-image: url('../assets/images/bg/5.jpg'); 
    background-size: 100%
  }

  .dark {
    background-image: url('../assets/images/bg/dark.jpg');

    background-size: 100%
  }

  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5) !important;
    background: rgba(255, 255, 255, 0.2) !important;
    -webkit-backdrop-filter: blur(20px) !important;
    backdrop-filter: blur(20px) !important;
    transform: perspective(500px) !important;
    transform-style: preserve-3d !important;
  }

  .card-dark {
    border-radius: 1em;
    border: 1px solid rgba(0, 0, 0, 0.5)!important;
    text-shadow: 0 0 1em rgba(245, 245, 245, 0.5)!important;
    background: rgba(0, 0, 0, 0.2)!important;
    -webkit-backdrop-filter: blur(20px)!important;
    backdrop-filter: blur(20px)!important;
    transform: perspective(500px)!important;
    transform-style: preserve-3d!important;
  }

</style>


<style lang="scss" scoped>
  .product-upgrade-to-pro {
    z-index: 4;
    top: 50%;
    right: 1px;
    position: fixed;

    .v-application &.v-btn.v-btn--is-elevated {
      box-shadow: 0 1px 20px 1px #ff4c51 !important;

      &:hover {
        box-shadow: none !important;
      }
    }
  }
</style>


<!--====  End of LAYOUT HORIZONTAL  ====-->